export const stringifySearchParameters = ( parameters ) => {
	if ( Object.keys( parameters ).length === 0 )
	{
		return '';
	}

	return '?' + Object.keys( parameters ).map( ( key ) => `${key}=${parameters[key]}&` ).join( '' ).slice( 0, -1 );
};